/**
 * 📥 DOWNLOAD TEMPLATE - Gains Monitor
 * Gera e faz download de um template Excel para importação em lote de Kaizens
 */

export const downloadGainsTemplate = async (): Promise<void> => {
  try {
    const XLSX = await import('xlsx');
    const { utils, writeFile } = XLSX;

    // ========================================================================
    // DADOS DO TEMPLATE - Exemplos de Kaizens
    // ========================================================================
    const templateData = [
      {
        titulo: 'Redução Lead Time - Processo XYZ',
        descricao: 'Automatizar etapa manual de validação de dados',
        tipo: 'reducao_lead_time',
        responsavel: 'João Silva',
        equipe: 'Maria Santos, Pedro Costa',
        data_planejada: '2026-03-01',
        data_alvo: '2026-06-30',
        baseline_lead_time: 120,
        target_lead_time: 60,
        baseline_cycle_time: 80,
        target_cycle_time: 40,
        baseline_ftr: 85,
        target_ftr: 95,
        baseline_capacity_fte: 2.5,
        target_capacity_fte: 1.8,
        baseline_cost: 15000,
        target_cost: 8000,
      },
      {
        titulo: 'Eliminação Desperdício - Retrabalho',
        descricao: 'Implementar checklist digital de qualidade',
        tipo: 'eliminacao_desperdicio',
        responsavel: 'Ana Martins',
        equipe: 'Carlos Oliveira',
        data_planejada: '2026-03-15',
        data_alvo: '2026-07-15',
        baseline_lead_time: 90,
        target_lead_time: 70,
        baseline_cycle_time: 60,
        target_cycle_time: 55,
        baseline_ftr: 75,
        target_ftr: 92,
        baseline_capacity_fte: 3,
        target_capacity_fte: 2.5,
        baseline_cost: 12000,
        target_cost: 9000,
      },
      {
        titulo: 'Automação - Entrada de Dados',
        descricao: 'RPA para captura automática de informações',
        tipo: 'automacao',
        responsavel: 'Ricardo Souza',
        equipe: 'Juliana Lima, Marcos Pereira',
        data_planejada: '2026-04-01',
        data_alvo: '2026-09-30',
        baseline_lead_time: 180,
        target_lead_time: 30,
        baseline_cycle_time: 150,
        target_cycle_time: 20,
        baseline_ftr: 90,
        target_ftr: 98,
        baseline_capacity_fte: 5,
        target_capacity_fte: 1,
        baseline_cost: 25000,
        target_cost: 5000,
      },
    ];

    // ========================================================================
    // CRIAR WORKSHEET DE DADOS
    // ========================================================================
    const dataSheet = utils.json_to_sheet(templateData);
    
    // Definir largura das colunas
    dataSheet['!cols'] = [
      { wch: 40 }, // titulo
      { wch: 50 }, // descricao
      { wch: 25 }, // tipo
      { wch: 25 }, // responsavel
      { wch: 35 }, // equipe
      { wch: 15 }, // data_planejada
      { wch: 15 }, // data_alvo
      { wch: 20 }, // baseline_lead_time
      { wch: 20 }, // target_lead_time
      { wch: 20 }, // baseline_cycle_time
      { wch: 20 }, // target_cycle_time
      { wch: 15 }, // baseline_ftr
      { wch: 15 }, // target_ftr
      { wch: 20 }, // baseline_capacity_fte
      { wch: 20 }, // target_capacity_fte
      { wch: 15 }, // baseline_cost
      { wch: 15 }, // target_cost
    ];

    // ========================================================================
    // CRIAR WORKSHEET DE INSTRUÇÕES
    // ========================================================================
    const instructions = [
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
      { A: '📊 TEMPLATE DE IMPORTAÇÃO - MONITOR DE SUSTENTAÇÃO DE GANHOS', B: '', C: '', D: '' },
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '📋 INSTRUÇÕES DE USO:', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '1. Preencha a aba "Kaizens" com os dados das melhorias', B: '', C: '', D: '' },
      { A: '2. Use os exemplos fornecidos como referência para o formato correto', B: '', C: '', D: '' },
      { A: '3. NÃO altere os nomes das colunas (cabeçalhos)', B: '', C: '', D: '' },
      { A: '4. Após preencher, salve o arquivo e importe pela opção "Importar Excel"', B: '', C: '', D: '' },
      { A: '5. O sistema criará automaticamente os Kaizens no Monitor de Ganhos', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
      { A: '📊 DESCRIÇÃO DOS CAMPOS:', B: '', C: '', D: '' },
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '📝 CAMPOS OBRIGATÓRIOS:', B: '', C: '', D: '' },
      { A: '  • titulo: Nome da melhoria Kaizen', B: '', C: '', D: '' },
      { A: '  • tipo: Tipo de melhoria (ver opções abaixo)', B: '', C: '', D: '' },
      { A: '  • responsavel: Nome do responsável pela implementação', B: '', C: '', D: '' },
      { A: '  • data_planejada: Data de início planejada (formato: YYYY-MM-DD)', B: '', C: '', D: '' },
      { A: '  • data_alvo: Data alvo de conclusão (formato: YYYY-MM-DD)', B: '', C: '', D: '' },
      { A: '  • baseline_lead_time: Lead Time atual/baseline em MINUTOS', B: '', C: '', D: '' },
      { A: '  • target_lead_time: Lead Time alvo em MINUTOS', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '📝 CAMPOS OPCIONAIS:', B: '', C: '', D: '' },
      { A: '  • descricao: Descrição detalhada da melhoria', B: '', C: '', D: '' },
      { A: '  • equipe: Membros da equipe separados por vírgula', B: '', C: '', D: '' },
      { A: '  • baseline_cycle_time: Cycle Time baseline em minutos', B: '', C: '', D: '' },
      { A: '  • target_cycle_time: Cycle Time alvo em minutos', B: '', C: '', D: '' },
      { A: '  • baseline_ftr: First Time Right atual em % (0-100)', B: '', C: '', D: '' },
      { A: '  • target_ftr: First Time Right alvo em % (0-100)', B: '', C: '', D: '' },
      { A: '  • baseline_capacity_fte: Capacidade atual em FTE', B: '', C: '', D: '' },
      { A: '  • target_capacity_fte: Capacidade alvo em FTE', B: '', C: '', D: '' },
      { A: '  • baseline_cost: Custo anual atual em R$', B: '', C: '', D: '' },
      { A: '  • target_cost: Custo anual alvo em R$', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
      { A: '🏷️  TIPOS DE KAIZEN (valores aceitos para a coluna "tipo"):', B: '', C: '', D: '' },
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '  • reducao_lead_time: Redução de Lead Time', B: '', C: '', D: '' },
      { A: '  • eliminacao_desperdicio: Eliminação de Desperdício', B: '', C: '', D: '' },
      { A: '  • automacao: Automação de Processo', B: '', C: '', D: '' },
      { A: '  • padronizacao: Padronização', B: '', C: '', D: '' },
      { A: '  • qualidade: Melhoria de Qualidade', B: '', C: '', D: '' },
      { A: '  • ergonomia: Ergonomia e Segurança', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
      { A: '⚠️  OBSERVAÇÕES IMPORTANTES:', B: '', C: '', D: '' },
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '  ⚠️  Datas devem estar no formato YYYY-MM-DD (exemplo: 2026-03-15)', B: '', C: '', D: '' },
      { A: '  ⚠️  Tempos (Lead Time, Cycle Time) devem estar em MINUTOS', B: '', C: '', D: '' },
      { A: '  ⚠️  FTR (First Time Right) deve ser um número entre 0 e 100', B: '', C: '', D: '' },
      { A: '  ⚠️  Target Lead Time deve ser menor que Baseline Lead Time', B: '', C: '', D: '' },
      { A: '  ⚠️  Valores numéricos não devem conter símbolos (R$, %, etc)', B: '', C: '', D: '' },
      { A: '  ⚠️  Não deixe linhas em branco entre os Kaizens', B: '', C: '', D: '' },
      { A: '', B: '', C: '', D: '' },
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
      { A: '✅ PRONTO PARA USAR!', B: '', C: '', D: '' },
      { A: '   Edite a aba "Kaizens" e depois importe o arquivo no sistema.', B: '', C: '', D: '' },
      { A: '═══════════════════════════════════════════════════════════════════════', B: '', C: '', D: '' },
    ];

    const instructionsSheet = utils.json_to_sheet(instructions);
    instructionsSheet['!cols'] = [{ wch: 80 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];

    // ========================================================================
    // CRIAR WORKBOOK E ADICIONAR SHEETS
    // ========================================================================
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, instructionsSheet, 'Instruções');
    utils.book_append_sheet(workbook, dataSheet, 'Kaizens');

    // ========================================================================
    // SALVAR ARQUIVO
    // ========================================================================
    const fileName = `Template_GainsMonitor_${new Date().toISOString().split('T')[0]}.xlsx`;
    writeFile(workbook, fileName);

    console.log(`✅ Template Excel gerado: ${fileName}`);
  } catch (error) {
    console.error('Erro ao gerar template:', error);
    throw new Error('Falha ao gerar template Excel. Tente novamente.');
  }
};
